export enum Links {
    // SUBSCRIPTION LINKS
    CP = 'cp',
    CP_20 = 'cp_20',
    ET = 'et',
    IU = 'iu',
    CM = 'cm',
    TWENTY_TWENTY_TWO = '2022',
    ST = 'st',
    SP = 'sp',
    SP99_Y = 'sp99_y',
    SP99_Y_20 = 'sp99_y_20',
    PTCC = 'ptcc',
    CP99 = 'cp99',
    CP99_20 = 'cp99_20',
    IU99 = 'iu99',
    IU99_20 = 'iu99_20',
    IU99_20_ALL = 'iu99_20_all',
    IU99_Y = 'iu99_y',
    REACTIVATE = 'reactivate',
    ADD_PAYMENT = 'add-payment',
    PREM298ANN = 'prem298ann',
    PREM298ANN20 = 'prem298ann20',
    // TRACKING LINKS
    TRACK = 'track',
    TRACK_DAY = 'track-day',
    TARGETS = 'targets',
    CONFIRM = 'confirm',
    AFTERNOON_REMINDER = 'afternoon-reminder',
    // COMMUNITY LINKS
    COMMUNITY = 'community',
    JOURNAL = 'journal',
    POST = 'post',
    // CHALLENGE LINKS
    FEABRUARY_CHALLENGE = 'february-challenge',
    DRY_JANUARY = 'dry-january',
    DRY_JULY = 'dry-july',
    SOBERISH_MOM = 'soberish-mom',
    DRY_JANUARY_REACTIVATE = 'dry-january-reactivate',
    DRY_JULY_REACTIVATE = 'dry-july-reactivate',
    CHALLENGE = 'challenge',
    CHALLENGE_COMPLETE = 'challenge-complete',
    CHALLENGE_REACTIVATE = 'challenge-reactivate',
    CHALLENGE_INVITE = 'challenge-invite',
    CHALLENGE_FEATURED = 'challenge-featured',
    CHALLENGE_LIFESTYLE = 'challenge-lifestyle',
    CHALLENGE_NEW = 'challenge-new',
    // RESOURCES LINKS
    RESOURCES = 'resources',
    RESOURCES_READING = 'resources-reading',
    RESOURCES_EXERCISE = 'resources-exercise',
    RESOURCES_VIDEO = 'resources-video',
    // MISC LINKS
    PROG = 'prog',
    PROF = 'prof',
    INVITE = 'invite',
    INVITE_3 = 'invite-3',
    PLAN = 'plan',
    SEE_PLAN = 'see-plan',
    DIAG = 'diag',
    DIAG_ID = 'diagId',
    NOTIFICATION_CONFIG = 'notification-config',
    CONFIG = 'config',
    COACHING = 'coaching',
    FWD = 'fwd',
    APP_REVIEW = 'app-review',
    APPLE_HEALTH = 'apple-health',
    ONBOARDING = 'onboarding'
}
